module.exports = __webpack_public_path__ + "img/tile-type-desktop_en.72e3fca.jpg";